// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__13BHB","productName":"Table_productName__9XiHz"};